var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "navbar" },
    [
      _c("hamburger", {
        staticClass: "hamburger-container",
        attrs: { id: "hamburger-container", "is-active": _vm.sidebar.opened },
        on: { toggleClick: _vm.toggleSideBar }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "right-menu" },
        [
          _vm.device !== "mobile"
            ? [
                _vm.env !== "development" &&
                _vm.env !== "production" &&
                _vm.env !== "staging"
                  ? [
                      _c("search", {
                        staticClass: "right-menu-item",
                        attrs: { id: "header-search" }
                      }),
                      _vm._v(" "),
                      _c("error-log", {
                        staticClass:
                          "errLog-container right-menu-item hover-effect"
                      }),
                      _vm._v(" "),
                      _c("screenfull", {
                        staticClass: "right-menu-item hover-effect",
                        attrs: { id: "screenfull" }
                      }),
                      _vm._v(" "),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: "Global Size",
                            effect: "dark",
                            placement: "bottom"
                          }
                        },
                        [
                          _c("size-select", {
                            staticClass: "right-menu-item hover-effect",
                            attrs: { id: "size-select" }
                          })
                        ],
                        1
                      )
                    ]
                  : _vm._e()
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "right-menu-item" },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "200px" },
                  attrs: {
                    value: _vm.selectedLegalEntity,
                    size: "mini",
                    filterable: ""
                  },
                  on: { change: _vm.handleChange }
                },
                _vm._l(_vm.legalEntities, function(item) {
                  return _c(
                    "el-option",
                    {
                      key: item.key,
                      attrs: {
                        label:
                          (_vm.hasMultipleParticipants
                            ? item.participant.name + " - "
                            : "") +
                          (item.legal_entity
                            ? item.legal_entity.display_name ||
                              item.legal_entity.registration_name
                            : _vm.$t("general.all_legal_entities")),
                        value: item.key
                      }
                    },
                    [
                      _vm.hasMultipleParticipants
                        ? [
                            _c("span", { staticStyle: { float: "left" } }, [
                              _vm._v(_vm._s(item.participant.name))
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  float: "right",
                                  color: "#8492a6",
                                  "font-size": "13px"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    item.legal_entity
                                      ? item.legal_entity.display_name ||
                                          item.legal_entity.registration_name
                                      : _vm.$t("general.all_legal_entities")
                                  )
                                )
                              ]
                            )
                          ]
                        : [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  item.legal_entity
                                    ? item.legal_entity.display_name ||
                                        item.legal_entity.registration_name
                                    : _vm.$t("general.all_legal_entities")
                                )
                              )
                            ])
                          ]
                    ],
                    2
                  )
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("lang-select", { staticClass: "right-menu-item hover-effect" }),
          _vm._v(" "),
          _c(
            "el-dropdown",
            {
              staticClass: "avatar-container right-menu-item hover-effect",
              attrs: { trigger: "click" }
            },
            [
              _c("div", { staticClass: "avatar-wrapper" }, [
                _c("img", {
                  staticClass: "user-avatar",
                  staticStyle: { "vertical-align": "middle" },
                  attrs: { src: require("@/assets/risolto_logo.png") }
                }),
                _vm._v(" "),
                _c("i", { staticClass: "el-icon-caret-bottom" })
              ]),
              _vm._v(" "),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: "/profile/index" } },
                    [_c("el-dropdown-item", [_vm._v("Account info")])],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isLoggedIn
                    ? _c("el-dropdown-item", { attrs: { divided: "" } }, [
                        _c(
                          "span",
                          {
                            staticStyle: { display: "block" },
                            on: { click: _vm.logout }
                          },
                          [_vm._v("Log Out")]
                        )
                      ])
                    : _c("el-dropdown-item", { attrs: { divided: "" } }, [
                        _c(
                          "span",
                          {
                            staticStyle: { display: "block" },
                            on: { click: _vm.login }
                          },
                          [_vm._v("Log In")]
                        )
                      ])
                ],
                1
              )
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }